export default {
  computed: {
    isUpdate() {
      let { name } = this.$route;
      return name === "customer-update" || name == "job-update";
    },
    isJob() {
      let { name } = this.$route;
      return name == "job-update";
    },
    isCreate() {
      let { name } = this.$route;
      return name === "customer-create";
    },
    isCustomer() {
      let { name } = this.$route;
      return name === "customer-create" || name == "customer-update";
    },
    jobTemplates() {
      let templates = this.$store.getters.templates;
      let list = [];
      templates.forEach(item => {
        let { type } = item;
        if (type === 0) list.push(item);
      });
      list = list.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      return list;
    },
    customerId() {
      return this.$route.params.id;
    }
  }
};
